// extracted by mini-css-extract-plugin
export default {"totalPrice":"sovag","withSeatingPlan":"G5P4o","totalPriceRow":"iSa8j"};